import { Col, Input, Row, Select, Space } from 'antd';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';

import { useInitialStepOptions } from 'src/features/programsV2/hooks/useInitialStepOptions';
import { InitialStepForm } from 'src/features/programsV2/schemas/initialStepSchema';

import { ProgramFormItem } from '../../ProgramFormItem';
import { CreateInstructor } from './CreateInstructor';

const { TextArea } = Input;

export const ProgramDetails: FC = () => {
  const { initialStepOptions, loadingOptions } = useInitialStepOptions();

  const { control } = useFormContext<InitialStepForm>();

  return (
    <Space direction='vertical' size={24} style={{ width: '100%' }}>
      <Row style={{ width: '100%' }}>
        <Col span={12} style={{ paddingRight: '12px' }}>
          <ProgramFormItem
            control={control}
            name='name'
            label='Nome do programa'
            renderItem={({ field }) => (
              <Input
                {...field}
                disabled={false}
                style={{ width: '100%' }}
                placeholder='Digite o nome'
              />
            )}
          />
        </Col>

        <Col
          span={12}
          style={{
            display: 'flex',
            paddingLeft: '12px',
            position: 'relative',
            flexDirection: 'column',
          }}
        >
          <ProgramFormItem
            control={control}
            name='instructorIds'
            label='Treinadores (Opcional)'
            isLoading={loadingOptions}
            renderItem={({ field }) => (
              <Select
                {...field}
                mode='multiple'
                showSearch
                filterOption={(input, option) =>
                  (option?.label ?? '')
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={initialStepOptions.instructors}
                style={{ width: '100%' }}
                placeholder='Selecionar'
              />
            )}
          />
          <CreateInstructor
            buttonStyle={{
              top: 0,
              right: 0,
              margin: 0,
              padding: 0,
              height: 'auto',
              border: 'none',
              position: 'absolute',
            }}
          />
        </Col>
      </Row>
      <Row style={{ width: '100%' }}>
        <Col span={12} style={{ paddingRight: '12px' }}>
          <ProgramFormItem
            control={control}
            name='segmentId'
            label='Segmentação'
            renderItem={({ field }) => (
              <Select
                {...field}
                showSearch
                filterOption={(input, option) =>
                  (option?.label ?? '')
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                placeholder='Selecionar'
                options={initialStepOptions.segments}
                style={{ width: '100%' }}
              />
            )}
          />
        </Col>
        <Col span={12} style={{ paddingLeft: '12px' }}>
          <ProgramFormItem
            control={control}
            name='typeProgramId'
            label='Tipo de programa'
            isLoading={loadingOptions}
            renderItem={({ field }) => (
              <Select
                {...field}
                options={initialStepOptions.types}
                style={{ width: '100%' }}
                placeholder='Selecionar'
              />
            )}
          />
        </Col>
      </Row>

      <Row style={{ width: '100%' }}>
        <Col span={24}>
          <ProgramFormItem
            control={control}
            name='description'
            label='Descrição (Opcional)'
            renderItem={({ field }) => (
              <TextArea
                {...field}
                placeholder='Descreva aqui...'
                rows={4}
                showCount={true}
                maxLength={500}
              />
            )}
          />
        </Col>
      </Row>
    </Space>
  );
};
